module.exports = __webpack_public_path__ + "static/3-f6c4798c48a3c62d3dfa8b37ca8a2111.jpg";